import { axios } from '@/api/request'

/**
 * api接口列表
 */
const api = {
  login:'/qywxLogin/',
  getproducts:'/teams/products/'

}

export function login (data) {
  return axios({
    url: api.login,
    method: 'post',
    data
  })
}

export function getproducts (params) {
  return axios({
    url: api.getproducts,
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/views/salerviews/products/api.js